import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
@Entity('sub_contractors')
export class SubContractors {
  @PrimaryGeneratedColumn("increment",{name:'sub_contractor_id'})
  subContractorId:number;
  // @Column("char",{
  //   nullable:false,
  //   length:15,
  //   name:"sub_contractor_code"
  //   })
  // // @Index({unique:true})
  // subContractorCode:string;
   @Column("char",{
    nullable:false,
    length:15,
    name:"pan_card_no"
    })
  // @Index({unique:true})
  panCardNo:string;
  @Column("varchar",{
    nullable:false,
    length:30,
    name:"sub_contractor_name"
    })
    @Index({unique:true})
  subContractorName:string;
  @Column("varchar",{
    nullable:false,
    length:30,
    name:"email_id"
    })
  emailId:string;
  @Column("varchar",{
    nullable:false,
    length:30,
    name:"mobile_no"
    })
  mobileNo:string;
  @Column("varchar",{
    nullable:false,
    length:30,
    name:"bank_acc_number"
    })
  bankAccNumber:string;
  @Column("varchar",{
    nullable:false,
    length:30,
    name:"ifsc_code"
    })
  ifscCode:string;
  @Column("varchar",{
    nullable:false,
    length:30,
    name:"branch_name"
    })
    branchName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"status"
    })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("int", {
      nullable: false,
      name: "created_user"
  })
  createdUser: number | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
}